import gql from "graphql-tag";

export default gql`
  query AmericanIssuerDividends(
    $tickerSymbol: TickerSymbol!
    $securityCountry: SecurityCountry!
    $filterByExcludingFrom: Int
    $filterByExcludingTo: Int
  ) {
    dividendsPaid(
      tickerSymbol: $tickerSymbol
      country: $securityCountry
      filterByExcludingFrom: $filterByExcludingFrom
      filterByExcludingTo: $filterByExcludingTo
    ) {
      nodes {
        tickerSymbol
        recordDate
        excludingDate
        payDate
        amountPaid
        dividendType
        distributionFrequency
      }
      dividendsPaidByYear {
        tickerSymbol
        fiscalYear
        amountPaid
      }
      dividendYieldByTickerSymbol {
        tickerSymbol
        dividendYield
        amountPaid
      }
      availableYears
    }

    americanIssuerSpecialDividendsPaid(tickerSymbol: $tickerSymbol, country: $securityCountry) {
      recordDate
      excludingDate
      payDate
      amountPaid
    }

    stockDividendsPaid(tickerSymbol: $tickerSymbol, country: $securityCountry) {
      tickerSymbol
      excludingDate
      sharePaid
    }
  }
`;
